var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_contract clearfix"},[_c('div',{staticClass:"left_content_contract"},[_c('nav-slider')],1),_c('div',{staticClass:"right_content_contract"},[_c('content-wrap')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }